import { Skeleton } from "@/components/ui/skeleton";

interface InfoCardProps {
	icon: React.ReactNode;
	label: string;
	value: React.ReactNode;
}

export function InfoCard({ icon, label, value }: InfoCardProps) {
	return (
		<div className="flex items-center gap-3 rounded-lg border bg-card px-4 py-3">
			<div className="flex size-9 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground">
				{icon}
			</div>
			<div className="flex min-w-0 flex-col">
				<span className="text-xs text-muted-foreground">{label}</span>
				<span className="truncate text-sm font-medium">{value}</span>
			</div>
		</div>
	);
}

export function InfoCardSkeleton() {
	return (
		<div className="flex items-center gap-3 rounded-lg border bg-card px-4 py-3">
			<Skeleton className="size-9 rounded-md" />
			<div className="flex flex-col gap-1">
				<Skeleton className="h-3 w-16" />
				<Skeleton className="h-4 w-24" />
			</div>
		</div>
	);
}
